import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { RnLicenseFullVM } from 'src/app/shared/services/rnapi2-service';

@Injectable({
  providedIn: 'root'
})
export class LicenseEditModalService extends BaseModalService<RnLicenseFullVM> {}
